module.exports = __webpack_public_path__ + "static/media/noun_account_1581254.d18d5ace.svg";